import { render, staticRenderFns } from "./LandingPageSocial.vue?vue&type=template&id=05a74b80"
import script from "./LandingPageSocial.vue?vue&type=script&lang=js"
export * from "./LandingPageSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports